module.exports = __webpack_public_path__ + "img/bb-logo-colored.97ee0752.svg";